








































import Vue from 'vue'
import { getInRoomLabel, getMapCalloutStatus, getPatientName, isInAnyRoom, isInOwnRoom } from '@/utils/patients'
import StatusCircle from '@/components/map/StatusCircle.vue'
import MapStatusLabel from '@/components/map/MapStatusLabel.vue'
import {
  getEventDescription,
  getFriendlyEventName,
  getMapEventName,
} from '@/view-model/patient-event-constants/MemberPatientEvents'
import { URGENT_EVENT_SEVERITY } from '@/utils/constants'
import { COMMON_ICONS_BASE64, convertBase64ForSrc } from '@/utils/image-utils'
export default Vue.extend({
  components: { StatusCircle, MapStatusLabel },
  props: {
    patient: {
      type: Object,
      default: null,
    },
    marginBottom: {
      type: Number,
      default: -20,
    },
  },
  computed: {
    eventStatus() {
      return this.patient && getMapCalloutStatus(this.patient)
    },
    infoIcon(): string {
      return convertBase64ForSrc(COMMON_ICONS_BASE64.INFO_CIRCLE)
    },
    patientName() {
      return this.patient && getPatientName(this.patient)
    },
    locationIcon() {
      if (!this.patient) {
        return ''
      }
      if (isInOwnRoom(this.patient)) return 'location_on'
      else {
        return 'location_off'
      }
    },
    locationDescription() {
      if (!this.patient) {
        return null
      }
      if (isInAnyRoom(this.patient)) {
        if (this.patient.lastLocationName) {
          return 'IN ' + this.patient.lastLocationName.toUpperCase()
        } else {
          return 'IN ROOM'
        }
      } else {
        return 'UNKNOWN'
      }
    },
    mapEventName() {
      return getMapEventName(this.patient && this.patient.patientEvent && this.patient.patientEvent.eventName)
    },
    mapEventDescription() {
      if (!this.patient || !this.patient.patientEvent) {
        return null
      }
      let mapEventName = getMapEventName(this.patient.patientEvent.eventName)
      if (mapEventName) {
        return mapEventName //+ "<span style='padding-left: 10px'> ℹ</span>️"
      } else {
        return getFriendlyEventName(this.patient.patientEvent.eventName)
      }
    },
    eventDescription() {
      return this.patient && this.patient.patientEvent && getEventDescription(this.patient.patientEvent.eventName)
    },
    inRoomTime() {
      return this.patient && getInRoomLabel(this.patient)
    },
    patientEventColor() {
      if (!this.patient || !this.patient.patientEvent) {
        return null
      }
      if (this.patient.patientEvent.eventSeverity < URGENT_EVENT_SEVERITY) {
        return this.$vuetify.theme.themes.light.orange
      } else {
        return this.$vuetify.theme.themes.light.red
      }
    },
    bubbleCssVars() {
      return {
        '--bubble-margin-bottom': this.marginBottom + 'px',
        '--event-color': this.patientEventColor,
      }
    },
  },
})
